var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"embed-entry"},[(_vm.loading)?_c('p',[_vm._v("正在进入 BMS…")]):(_vm.errorMsg)?_c('p',{staticClass:"embed-entry__error"},[_vm._v(_vm._s(_vm.errorMsg))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }